import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { FreeBeatsSortBy } from '../../../enums/enums'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-free-beats-page',
  templateUrl: './bmcore-free-beats-page.component.html',
  styleUrls: ['./bmcore-free-beats-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFreeBeatsPageComponent implements OnInit {
  constructor(
    private titleService: Title,
    private i18nService: I18nService
  ) {
    this.lg = this.i18nService.getLanguageForPage()
    this.titleService.setTitle(`${this.lg.documentTitles.freeBeats}`)
  }
  @Input() appType: AppType

  lg: LgType

  protected readonly FreeBeatsSortBy = FreeBeatsSortBy

  ngOnInit(): void {}
}
